import { useEffect, useState } from 'react'
import '../../styles/userEntry.scss'
import { NavLink, useNavigate, } from 'react-router-dom'
import LoaderBtn from '../LoaderBtn/LoaderBtn'
import { useNotification } from '../../context/NotificationContext'
import { signupUser } from '../../api/requests'
import 'animate.css'
import { EyeIcon, EyeOff } from 'lucide-react'

const SignUpArea = () => {
    const { notify } = useNotification();
    const navigate = useNavigate()


    const [signUpData, setSignUpData] = useState({
        fullname: '',
        firstname: '',
        lastname: '',
        phonenumber: '',
        emailaddress: '',
        password: '',
        showPassword: false,
        showConfirmPassword: false,
        confirm_password: '',
        referral_id: '',
        remember_me: false,
        is_tp_agreed: false,
        isLoading: false
    })



    const handleInput = (key: string, value: string | boolean) => {

        setSignUpData((prev) => {
            return {
                ...prev,
                [key]: value
            }
        })

    }



    useEffect(() => {

        const pacContainers = document.querySelectorAll('.pac-container') as NodeListOf<HTMLElement>;
        pacContainers.forEach((pac) => {
            pac.style.borderTop = 'none';
        });

    }, []);




    const setSignUpLoader = (value: boolean) => {
        setSignUpData((prev) => {
            return {
                ...prev,
                isLoading: value
            }
        })
    }

    function isValidPhoneNumber(phone: string) {
        return /^\+?[0-9\s-]{10,15}$/.test(phone);
    }


    function isValidEmail(email: string) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }



    const handleSignUp = async () => {
        if (signUpData.emailaddress === '' || signUpData.password === '' || signUpData.confirm_password === '' || signUpData.firstname === '' || signUpData.lastname === '' || signUpData.phonenumber === ''
        ) {
            notify.error('Please fill in the required fields to continue')
            return
        }

        if (!isValidEmail(signUpData.emailaddress)) {
            notify.error('Invalid e-mail address')
            return
        }

        if (!isValidPhoneNumber(signUpData.phonenumber)) {
            notify.error('Invalid phone number')
            return
        }

        if (signUpData.password !== signUpData.confirm_password) {
            notify.error('Password and confirm password does not match')
            return
        }

        if (!signUpData.is_tp_agreed) {
            notify.error('Terms and privacy policy is required to continue')
            return
        }

        try {
            setSignUpLoader(true)



            let obj = {
                email: signUpData.emailaddress,
                name: signUpData.fullname,
                first_name: signUpData.firstname,
                last_name: signUpData.lastname,
                telephone_no: signUpData.phonenumber,
                password: signUpData.password,
                confirm_password: signUpData.confirm_password,
                ...(signUpData.referral_id && signUpData.referral_id !== '' && { referral_code: signUpData.referral_id }),

            };
            console.log(obj)
            let result = await signupUser(obj)

            if (result) {

                let stateData = {
                    email: signUpData.emailaddress,
                    afterVerificationUrl: '/signin'
                }

                navigate('/signup/verify', {
                    state: stateData
                });


            }

        } catch (error: any) {
            notify.error(error.message)
        } finally {
            setSignUpLoader(false)
        }

    }

    return (
        <div className="sectionarea">


            <div className='content animate__animated animate__fadeIn animate__fast'>
                <NavLink to={'/'}>
                    <div className='logoArea'>
                        <div className='icon logo_initials'></div>
                        <div className='icon logo_name'></div>
                    </div>
                </NavLink>

                <div className='intro'>
                    <div className='title'>Create account</div>
                    <div className='text'>For business, band or celebrity.</div>
                </div>


                <div className='inputAreaGrid'>


                    {/* <div className='inputPack'>
                        <label className='inputTitle'>Username</label>
                        <input className='inputBox' type='text' value={signUpData.fullname} onChange={(ev) => handleInput('fullname', ev.currentTarget.value)}></input>
                    </div> */}

                    <div className='inputPack'>
                        <label className='inputTitle'>First name</label>
                        <input className='inputBox' type='text' value={signUpData.firstname} onChange={(ev) => handleInput('firstname', ev.currentTarget.value)}></input>
                    </div>

                    <div className='inputPack'>
                        <label className='inputTitle'>Last name</label>
                        <input className='inputBox' type='text' value={signUpData.lastname} onChange={(ev) => handleInput('lastname', ev.currentTarget.value)}></input>
                    </div>

                    <div className='inputPack'>
                        <label className='inputTitle'>Phone number</label>
                        <input className='inputBox' type='text' value={signUpData.phonenumber} onChange={(ev) => handleInput('phonenumber', ev.currentTarget.value)}></input>
                    </div>

                    <div className='inputPack'>
                        <label className='inputTitle'>Email Address</label>
                        <input className='inputBox' type='email' value={signUpData.emailaddress} onChange={(ev) => handleInput('emailaddress', ev.currentTarget.value)}></input>
                    </div>

                    <div className='inputPack'>
                        <label className='inputTitle'>Referral Code</label>
                        <input className='inputBox' type='text' value={signUpData.referral_id} onChange={(ev) => handleInput('referral_id', ev.currentTarget.value)}></input>
                    </div>

                    <div className='inputPack'>
                        <label className='inputTitle'>Password</label>
                        <input className='inputBox' type={`${signUpData.showPassword ? 'text' : 'password'}`} value={signUpData.password} onChange={(ev) => handleInput('password', ev.currentTarget.value)}></input>

                        <div className='eyepack'>
                            {signUpData.showPassword && (<EyeOff onClick={() => setSignUpData((prev) => { return { ...prev, showPassword: !prev.showPassword } })}></EyeOff>)}
                            {!signUpData.showPassword && (<EyeIcon onClick={() => setSignUpData((prev) => { return { ...prev, showPassword: !prev.showPassword } })}></EyeIcon>)}
                        </div>

                    </div>


                    <div className='inputPack'>
                        <label className='inputTitle'>Confirm Password</label>
                        <input className='inputBox' type={`${signUpData.showConfirmPassword ? 'text' : 'password'}`} value={signUpData.confirm_password} onChange={(ev) => handleInput('confirm_password', ev.currentTarget.value)}></input>

                        <div className='eyepack'>
                            {signUpData.showConfirmPassword && (<EyeOff onClick={() => setSignUpData((prev) => { return { ...prev, showConfirmPassword: !prev.showConfirmPassword } })}></EyeOff>)}
                            {!signUpData.showConfirmPassword && (<EyeIcon onClick={() => setSignUpData((prev) => { return { ...prev, showConfirmPassword: !prev.showConfirmPassword } })}></EyeIcon>)}
                        </div>
                    </div>

                </div>




                <div className='flex space-btw' style={{ marginBottom: '20px' }}>

                    <div className='flex'>
                        <input className='checkbox' type='checkbox' checked={signUpData.remember_me} onChange={(ev) => handleInput('remember_me', ev.currentTarget.checked)}></input>
                        <div className='rmem'>Remember Me</div>
                    </div>



                    <NavLink to='/signin/forgotpassword'><div className='fgpass'>Forgot password?</div></NavLink>

                </div>



                <div className='flex space-btw'>

                    <div className='flex'>
                        <input className='checkbox' type='checkbox' checked={signUpData.is_tp_agreed} onChange={(ev) => handleInput('is_tp_agreed', ev.currentTarget.checked)}></input>
                        <div className='rmem'>I agree to all the <NavLink to={'/terms-conditions'} target='_blank'><span className='highlight'>Terms</span></NavLink> and <NavLink to={'/privacypolicy'} target='_blank'><span className='highlight'>Privacy policy</span></NavLink></div>
                    </div>

                </div>

                <div className='btn_grid'>

                    <LoaderBtn className={'btn'} text={'Create account'} thickness={3} isLoading={signUpData.isLoading} clickFunction={handleSignUp}></LoaderBtn>

                    {/* <div className='btn' onClick={handleSignUp}>
                        Create account
                    </div> */}

                    {/* <div className='btn google'>
                        <div className='google_icon'></div>
                        <span>Sign-in with google</span>
                    </div> */}
                </div>


                <div className='flex_center tc'>
                    <NavLink to={'/signin'}> <div className='crt_acc'>Do you have an account? <span className='highlight'>Log In</span></div></NavLink>
                </div>


                <div className='download_grid'>

                    <NavLink to={'https://apps.apple.com/app/yayako/id6744727249'} target='_blank'><div className='appicon appstore'></div></NavLink>
                    <NavLink to={'https://play.google.com/store/apps/details?id=com.yayako.yayako'} target='_blank'><div className='appicon googleplay'></div></NavLink>

                </div>


            </div>



        </div>
    )
}

export default SignUpArea;